import axios from 'axios';
import QueryString from 'qs';
import { useEffect } from 'react';
import axiosClient from '../libs/axiosClient';
import { setToken, getLoginErrorMessage } from './auth';
import { handleRedirectUrlCheck } from '../common/redirectUrlCheck';
import { useNavigate } from 'react-router-dom';

function Line() {
  const navigate = useNavigate();
  useEffect(() => {
    let params = new URL(document.URL).searchParams;
    let code = params.get('code');
    axiosClient
      .post(
        '/func/user/login/line',
        {
          code: code,
        },
        {
          headers: {
            'Access-Control-Allow-Origin': 'https://api.us.ondoc.co.kr',
          },
          withCredentials: true,
        },
      )
      .then((res) => {
        setToken(res.data);
        let rurl = localStorage.getItem('rurl');
        if (handleRedirectUrlCheck(rurl || '/')) navigate(rurl || '/');
        else navigate('/');
      })
      .catch((err) => {
        alert(getLoginErrorMessage(err));
        navigate('/login');
      });
  }, []);
  return <div></div>;
}
export default Line;
